export enum DocumentationPathsEnum {
  documentationPage = '/documentation',
  mobileUploadPage = '/documentation/upload',
}
